import type { Category } from "../support.types";

/**
 * Finds the category containing an article by article ID.
 * Recursively searches through subcategories.
 */
export function findSupportArticleInCategory(
  cats: Category[] = [],
  articleId: string
): Category | null {
  for (const cat of cats) {
    if (cat.articles.some((a) => a.id === articleId)) {
      return cat;
    }
    if (cat.subcategories.length > 0) {
      const found = findSupportArticleInCategory(cat.subcategories, articleId);
      if (found) return found;
    }
  }
  return null;
}

export default findSupportArticleInCategory;
